import GetSettingDto from '@settings/models/dto/get-setting.dto';
import UpdateSettingDto from '@settings/models/dto/update-setting.dto';
import { updateSettings } from '@settings/services/settingServices';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useUpdateSettings = () => {
  const updateVideoStepMutation = useMutation<
    AxiosResponse<GetSettingDto[]>,
    unknown,
    { payload: UpdateSettingDto[] },
    unknown
  >(({ payload }) => updateSettings(payload));

  return updateVideoStepMutation;
};
